import React from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { HelpText } from '../helpTexts';
import { cardSx, launchColors } from '../launchTheme';
import InfoTip from './InfoTip';

interface Props {
  value: number;
  label: string;
  fg: string;
  bg: string;
  accent: string;
  icon: React.ReactNode;
  info: HelpText;
  hint?: string;
  zeroText?: string | null;
  onClick?: () => void;
}

const KpiTile: React.FC<Props> = ({ value, label, fg, bg, accent, icon, info, hint = 'Visa i arbetslistan', zeroText, onClick }) => {
  const quietZero = value === 0 && zeroText === undefined;
  const spoken = quietZero ? 'Inget att göra' : (value === 0 && typeof zeroText === 'string' ? zeroText : hint);
  return (
    <Box sx={{
      ...cardSx,
      position: 'relative',
      border: `1px solid ${accent}`,
      borderLeft: `4px solid ${accent}`,
      bgcolor: bg,
      overflow: 'hidden',
    }}>
      <ButtonBase
        component="div"
        onClick={onClick}
        aria-label={`${label}: ${value}. ${spoken}`}
        sx={{
          display: 'block',
          textAlign: 'left',
          width: '100%',
          p: 1.75,
          pr: 5,
          borderRadius: '12px',
          '&:hover': { bgcolor: bg },
          '&.Mui-focusVisible': { outline: `2px solid ${launchColors.navy}`, outlineOffset: -2 },
        }}
      >
        <Box aria-hidden sx={{ color: fg, mb: 0.5, display: 'flex' }}>{icon}</Box>
        <Typography sx={{ display: 'flex', alignItems: 'center', gap: 0.75, fontSize: 28, fontWeight: 700, lineHeight: 1.1, color: fg, fontVariantNumeric: 'tabular-nums' }}>
          {value}
          {quietZero && <CheckCircleOutlineIcon sx={{ fontSize: 22, color: launchColors.moss }} />}
        </Typography>
        <Typography sx={{ fontSize: 13, fontWeight: 700, color: fg, mt: 0.25 }}>{label}</Typography>
        <Typography sx={{ fontSize: 12, color: launchColors.textSecondary, mt: 0.5 }}>
          {quietZero ? 'Inget att göra' : (value === 0 && typeof zeroText === 'string' ? zeroText : `${hint} →`)}
        </Typography>
      </ButtonBase>
      <Box sx={{ position: 'absolute', top: 6, right: 6 }}>
        <InfoTip text={info} />
      </Box>
    </Box>
  );
};

export default KpiTile;
